import { WalletAdapter } from '../types'
import { checkNativeWalletSupport, requestNativeWalletPayment } from 'utils/nativeApp'

/**
 * Google Pay wywoływany z poziomu natywnej aplikacji (Android). Web-owe SDK Google
 * (googlePay.ts) w WebView nie otwiera natywnego arkusza portfela, więc tu zamiast tego
 * przekazujemy żądanie do appki przez postMessage i czekamy na window.onNativeWalletResult -
 * kontrakt opisany w utils/nativeApp.ts (`requestNativeWalletPayment`) i types/global.d.ts
 * (`NativeWalletRequest` / `NativeWalletResult`).
 *
 * Appka sama sprawdza gotowość urządzenia (isReadyToPay) raz przy starcie i zgłasza ją w
 * window.__NATIVE_APP__.wallets - isAvailable tu jest więc tylko synchronicznym odczytem tej
 * flagi, bez żadnego dodatkowego zapytania do SDK.
 */
export const nativeGooglePayAdapter: WalletAdapter = {
  async isAvailable() {
    return checkNativeWalletSupport('gpay')
  },

  requestToken(walletForm, { amount, label, sandbox }) {
    return requestNativeWalletPayment({
      wallet: 'gpay',
      amount: amount.toFixed(2),
      currencyCode: walletForm.currencyCode,
      countryCode: walletForm.countryCode,
      supportedNetworks: walletForm.supportedNetworks,
      label,
      gateway: walletForm.gateway,
      gatewayMerchantId: walletForm.gatewayMerchantId,
      sandbox
    })
  }
}
